import {get} from "lodash";

export default {
    methods: {
        getImageUrls(product) {
            const images = product?.images ?? [];

            if (images === null || images.every(i => (typeof i === 'string'))) {
                return [];
            }

            if (images.length > 1) {
                return images
                    .map(image => {
                        return {
                            id:          image.id,
                            url:         image.src,
                            alt:         image.alt || '',
                            variant_ids: get(image, 'variant_ids', []).map(id => id.toString())
                        };
                    })
                    .filter(image => {
                        const invalidVariantIds = !!product?.variants ? product.variants
                                .filter(variant => {
                                    return variant.option_values.length !== variant.options.length;
                                })
                                .map(variant => variant.external_id)
                            : [];

                        if (invalidVariantIds.length > 0 && image.variant_ids.length === 0) {
                            return false;
                        }

                        return image.variant_ids.filter( variant_id => invalidVariantIds.includes(variant_id) ).length === 0;
                    }
                )
            }

            return [];
        },
    }
}
